import moment from 'moment';

export function calculateNights(arrivalDate, departureDate) {
  const hasArrivalDate = arrivalDate && moment(arrivalDate).isValid();
  const hasDepartureDate = departureDate && moment(departureDate).isValid();

  if (hasArrivalDate && hasDepartureDate && moment(arrivalDate).startOf('day').isBefore(moment(departureDate).startOf('day'))) {
    const totalNights = moment(departureDate).startOf('day').diff(moment(arrivalDate).startOf('day'), 'days');

    return {
      totalRoom: totalNights,
      nights: totalNights.toString()
    };
  }

  return {
    totalRoom: '',
    nights: '0'
  };
}
